/* bl-reviews-wall — repartit les avis dans la colonne la plus courte (mur facon Pinterest).
   Code maison BellvoLux. */
if (!customElements.get('bl-reviews-wall')) {
  class BlReviewsWall extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-bl-grid]');
      if (!this.grid) return;
      this.cards = Array.from(this.grid.querySelectorAll('[data-bl-card]'));
      this.more = this.querySelector('[data-bl-more]');
      if (this.more) {
        this.more.addEventListener('click', () => {
          const limit = parseInt(this.dataset.limit || '9', 10);
          const hidden = this.cards.filter((c) => c.classList.contains('is-hidden'));
          hidden.slice(0, limit).forEach((c) => c.classList.remove('is-hidden'));
          if (hidden.length <= limit) this.more.parentElement.hidden = true;
          this.layout(true);
        });
      }
      this.layout(true);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.layout(true));
      window.addEventListener('load', () => this.layout(true), { once: true });
      this._w = window.innerWidth;
      window.addEventListener('resize', () => {
        clearTimeout(this._t);
        this._t = setTimeout(() => this.layout(), 150);
      });
      this.querySelectorAll('img').forEach((img) => {
        if (!img.complete) img.addEventListener('load', () => this.layout(true), { once: true });
      });
    }

    columnCount() {
      const v = getComputedStyle(this.grid).getPropertyValue('--bl-cols').trim();
      return Math.max(1, parseInt(v, 10) || 2);
    }

    layout(force) {
      const n = this.columnCount();
      if (!force && n === this._n) return;
      this._n = n;
      this.grid.classList.add('is-masonry');
      this.grid.querySelectorAll('.bl-reviews__col').forEach((col) => col.remove());
      const cols = [];
      for (let i = 0; i < n; i++) {
        const col = document.createElement('div');
        col.className = 'bl-reviews__col';
        this.grid.appendChild(col);
        cols.push(col);
      }
      this.cards.forEach((card) => {
        if (card.classList.contains('is-hidden')) {
          cols[0].appendChild(card);
          return;
        }
        let target = cols[0];
        cols.forEach((c) => { if (c.offsetHeight < target.offsetHeight - 1) target = c; });
        target.appendChild(card);
      });
    }
  }
  customElements.define('bl-reviews-wall', BlReviewsWall);
}
